import api from "../../../../common/dependencies/utils/Api";

import {
  DELETE_MESSAGE_DATA,
  DASHBOARD_STARTUP_MYREQUEST,
  DASHBOARD_STARTUP_HOME,
  ALL_STARTUP_LIST,
  STARTUP_APPLICATION,
  VIEW_COUNTER_STARTUP_OPTIONS,
  GET_SUMMARY_DATA,
  POST_SUMMARY_STARTUP_DATA,
  DELETE_SESSION_STARTUP_DATA,
  MENTOR_REQUEST_MENTORS_LIST,
  POST_STARTUP_FEEDBACK,
  GET_STARTUP_FEEDBACK,
  POST_UPLOAD_DOCUMENT,
  GET_UPLOAD_DOCUMENT_LIST,
  STARTUP_ENGAGEMENT_NOTES,
  MENTOR_ENGAGEMENT_NOTES,
  POST_PROGRESS_REPORT,
  POST_IM_MESSAGE,
  POST_ALL_IM_MESSAGES,
  SESSION_CALENDAR,
  GET_ENGAGEMENT_NOTES,
  GET_STARTUP_MENTORSHIP_COUNTER,
  GET_NEW_MESSAGES,
  COHORT_REQUEST_STARTUP_DASHBOARD,
  MY_MENTOR_COUNTER,
  MY_STARTUPS_COUNTER,
  ALL_APPLICATION_STARTUP_LIST,
} from "../../../../common/constants/ApplicationUrl";

export const MentorServices = {
  getCohortRequest(params) {
    return api
      .POST(`${COHORT_REQUEST_STARTUP_DASHBOARD}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getRequestfromMentorList(params) {
    return api
      .POST(`${MENTOR_REQUEST_MENTORS_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },

  dashboardStartupMyrequest() {
    return api
      .GET(`${DASHBOARD_STARTUP_MYREQUEST}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  dashboardStartupHome(params) {
    return api
      .POST(`${DASHBOARD_STARTUP_HOME}`, params)
      .then((response) => {
        
        
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  allStartUpList(params) {
    return api
      .POST(`${ALL_STARTUP_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getStartUpapplicationList(params) {
    return api
      .POST(`${ALL_APPLICATION_STARTUP_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  AllSessionCalendar(params) {
    return api
      .POST(`${SESSION_CALENDAR}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  startUpApplication(params) {
    return api
      .POST(`${STARTUP_APPLICATION}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getCountersStartUpList(params) {
    return api
      .POST(`${VIEW_COUNTER_STARTUP_OPTIONS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getSummaryData(params) {
    return api
      .POST(`${GET_SUMMARY_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postSummaryData(params) {
    return api
      .POST(`${POST_SUMMARY_STARTUP_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postStartupFeedback(params) {
    return api
      .POST(`${POST_STARTUP_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getStartupFeedback(params) {
    return api
      .POST(`${GET_STARTUP_FEEDBACK}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
 
  postUploadDocument(params) {
    return api
      .POST(`${POST_UPLOAD_DOCUMENT}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postEngagementNotes(params) {
    const loginDataJson =JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role
    
    // 
    return api
      .POST(loginDataJson =="Startup"?`${STARTUP_ENGAGEMENT_NOTES}`:`${MENTOR_ENGAGEMENT_NOTES}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getEngagementNotes(params) {
    let value = localStorage.getItem("SavedLoggedInData");
    // 
    return api
    .POST(`${GET_ENGAGEMENT_NOTES}`, params)
    .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postProgressReport(params) {
    return api
      .POST(`${POST_PROGRESS_REPORT}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getUploadDocumentList(params) {
    return api
      .POST(`${POST_UPLOAD_DOCUMENT}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getStartUpMentorShip(params) {
    return api
      .POST(`${GET_STARTUP_MENTORSHIP_COUNTER}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMyStartupCounter(params) {
    return api
      .POST(`${MY_STARTUPS_COUNTER}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMyMentorCounter(params) {
    return api
      .POST(`${MY_MENTOR_COUNTER}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getAllImMessages(params) {
    return api
      .POST(`${POST_ALL_IM_MESSAGES}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  postSendImMessage(params) {
    return api
      .POST(`${POST_IM_MESSAGE}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  deleteSessionData(params) {
    return api
      .POST(`${DELETE_SESSION_STARTUP_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  deleteMessagedataoflist(params) {
    return api
      .POST(`${DELETE_MESSAGE_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getNewMessages(params) {
    return api
      .POST(`${GET_NEW_MESSAGES}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getNewMessages(params) {
    return api
      .POST(`${GET_NEW_MESSAGES}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
};
